import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { UserPropertiesComponent } from "./user-properties/user-properties.component";
import { Layouts } from "../app.component";
import { NewUserpropertiesComponent } from "./new-userproperties/new-userproperties.component";
import { NewAppPropertiesComponent } from "./new-app-properties/new-app-properties.component";
import { EditUserpropertiesComponent } from "./edit-userproperties/edit-userproperties.component";
import { DatastorePropertiesComponent } from "./datastore-properties/datastore-properties.component";
import { AppAuthGuard } from "../login/services/app.authguard";
import { environment } from "src/environments/environment.staging";

const routes: Routes = [
  {
    path: "user-settings",
    component: UserPropertiesComponent,
    data: { layout: Layouts.SecureLayout },
  },
  {
    path: "user-setting/:id",
    component: UserPropertiesComponent,
    data: { layout: Layouts.SecureLayout },
  },
  {
    path: "datastore-settings",
    component: DatastorePropertiesComponent,
    data: { layout: Layouts.SecureLayout, roles: [environment.roles.role_Ais_Admin] },
    canActivate: [AppAuthGuard],
  },
  {
    path: "new-user-setting",
    component: NewUserpropertiesComponent,
    data: { layout: Layouts.SecureLayout },
  },
  {
    path: "new-app-properties",
    component: NewAppPropertiesComponent,
    data: { layout: Layouts.SecureLayout },
  },
  {
    path: "edit-user-setting/:id",
    component: EditUserpropertiesComponent,
    data: { layout: Layouts.SecureLayout },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PropertiesRoutingModule {}
